import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aa15e77"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "app-h4" }
const _hoisted_3 = {
  key: 0,
  class: "header-tabs"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Order List")
const _hoisted_5 = {
  key: 0,
  class: "videographers-list"
}
const _hoisted_6 = { class: "videographers-item-label app-subtitle" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "header-tabs"
}
const _hoisted_9 = {
  key: 0,
  class: "videographers-list"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "videographers-item-label app-subtitle" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon icon_exit" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-subtitle" }, "Exit", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["header-title", { 'header-title_short': $setup.isGameOrderPage || $setup.isDistributionPage }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["icon", $setup.pageIcon])
      }, null, 2),
      _createElementVNode("div", _hoisted_2, _toDisplayString($setup.pageTitle), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["header-part", { 'header-part_short': !$setup.isGameOrderPage && !$setup.isDistributionPage }])
    }, [
      ($setup.isGameOrderPage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              class: "tab app-subtitle tab-link",
              to: { name: $setup.routesName.ordersNewGames },
              "active-class": "tab-link_active"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["to"]),
            ($setup.croppedVideographers.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.croppedVideographers, (v) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      class: "videographers-item tab tab-link",
                      key: v.id,
                      to: { name: $setup.routesName.ordersVideographer, params: { id: v.id } },
                      "active-class": "tab-link_active"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(`${v.first_name} ${v.last_name}`), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128)),
                  ($setup.hiddenVideographers.length)
                    ? (_openBlock(), _createBlock($setup["VideographersMenuButton"], {
                        key: 0,
                        data: $setup.hiddenVideographers
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(`+${$setup.hiddenVideographers.length}`), 1)
                        ]),
                        _: 1
                      }, 8, ["data"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7))
          ]))
        : ($setup.isDistributionPage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              ($setup.croppedVideographersByDay.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.croppedVideographersByDay, (v) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["videographers-item tab tab-link cursor-pointer", { 'tab-link_active': Number($setup.route.query.videographer_id) === v.id }]),
                        key: v.id,
                        onClick: ($event: any) => ($setup.route.query.videographer_id === String(v.id) ? $setup.router.push({ name: $setup.routesName.distributions, query: { ...Object.fromEntries(Object.entries($setup.route.query).filter(([key]) => key !== 'videographer_id')) } }) : $setup.router.push({ name: $setup.routesName.distributions, query: { ...$setup.route.query, videographer_id: v.id } }))
                      }, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(`${v.first_name} ${v.last_name}`), 1)
                      ], 10, _hoisted_10))
                    }), 128)),
                    ($setup.hiddenVideographersByDay.length)
                      ? (_openBlock(), _createBlock($setup["VideographersMenuButton"], {
                          key: 0,
                          data: $setup.hiddenVideographersByDay
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(`+${$setup.hiddenVideographersByDay.length}`), 1)
                          ]),
                          _: 1
                        }, 8, ["data"]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12))
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "exit",
        onClick: $setup.logout
      }, _hoisted_15)
    ], 2)
  ]))
}